<template>
  <button type="reset" @click="onClick()">
    <img :src="movieImg" />
  </button>
</template>

<script>
  export default {
    props: {
      btnNum: {
        type: String,
      },
      movieId: {
        type: String,
      },
      movieImg: {
        type: String, //文字列の宣言
      },
    },
    methods: {
      onClick() {
        this.$emit("modal-open", {
          movieId: this.movieId,
        });
      },
    },
  };
</script>
<style scoped>
  @import "../styles/common/css/movie.css";
</style>
